//medidad Banner 650x360px
export const ultimasNoticias = [
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Maraton Nacional de Teatro.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/5.-Convocatoria 18 Gran Maratón Nacional de Teatro.pdf",
        "titulo" : "Convocatoria Gran Maratón Nacional de Teatro para Niñas, Niños, Niñes y Adolescentes ",
        "fecha" : "del 16 de febrero al 26 de febrero"
    },
     {
        "imagen" :"../assets/imgs/Convocatorias/2026/Teatro y Literatura.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/1.-Resultados Teatro y Literatura.pdf",
        "titulo" : "Resultados de la oferta academica del Taller de Teatro y Literatura 2026",
        "fecha" : "13 de febrero del 2026"
    },
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Musica.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/2.-Resultados Musica.pdf",
        "titulo" : "Resultados de la oferta academica del Taller de Musica 2026",
        "fecha" : "13 de febrero del 2026"
    },
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Danza.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/3.-Resultados Danza.pdf",
        "titulo" : "Resultados de la oferta academica del Taller de Danza 2026",
        "fecha" : "13 de febrero del 2026"
    },
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Artes Visuales.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/4.-Resultados Visuales.pdf",
        "titulo" : "Resultados de la oferta academica del Taller de Artes Visuales 2026",
        "fecha" : "13 de febrero del 2026"
    },
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Banda Sinfónica.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/4.Convocatoria banda.pdf",
        "titulo" : "Convocatoria Banda Sinfónica del Centro de las Artes",
        "fecha" : "del 03 de febrero al 28 de febrero del 2026"
    },
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Coro.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/3.Convocatoria Coro Niñas y Niños Cantores de Hidalgo 2026.pdf",
        "titulo" : "Convocatoria Coro de Niñas y Niños Cantores de Hidalgo",
        "fecha" : "del 03 de febrero al 28 de febrero del 2026"
    },
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Orquesta Sinfónica.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/2.Convocatoria orquesta.pdf",
        "titulo" : "Convocatoria Orquesta Sinfónica Infantil y Juvenil del Centro de las Artes de Hidalgo",
        "fecha" : "del 03 de febrero al 28 de febrero del 2026"
    },

]